// Q4uDoc canonical exam vocab — proposed for @q4udoc/types
//
// Lifted from question_gen_gem/tag_questions.py ALL_EXAMINATIONS.
// This is the single source of truth for the "audience/exam" axis:
//   - Question.forExams[] entries must come from this list
//   - User.forExams[] entries must come from this list
//
// Adding a new exam: append here, publish @q4udoc/types, both python tagger and
// mobile onboarding picker read the new value on next update. Never mutate an
// existing string — that silently breaks matching for every question already tagged.

export const EXAMS = [
  // ---- General ----
  'General Medical Knowledge',
  'Continuing Medical Education (CME)',

  // ---- Licensing (allopathic + osteopathic) ----
  'USMLE Step 1',
  'USMLE Step 2 Clinical Knowledge (CK)',
  'USMLE Step 3',
  'COMLEX-USA Level 1',
  'COMLEX-USA Level 2 Cognitive Evaluation (CE)',
  'COMLEX-USA Level 3',

  // ---- NBME Clinical Shelf ----
  'Clinical Neurology Subject Examination',
  'Clinical Psychiatry Subject Examination',
  'Emergency Medicine Subject Examination',
  'Family Medicine Subject Examination',
  'Medicine Subject Examination',
  'Obstetrics & Gynecology Subject Examination',
  'Pediatrics Subject Examination',
  'Surgery Subject Examination',

  // ---- NBME Basic Science ----
  'Anatomy Subject Examination',
  'Behavioral Sciences Subject Examination',
  'Biochemistry Subject Examination',
  'Gross Anatomy & Embryology Subject Examination',
  'Histology & Cell Biology Subject Examination',
  'Microbiology Subject Examination',
  'Neuroscience Subject Examination',
  'Pathology Subject Examination',
  'Pharmacology Subject Examination',
  'Physiology Subject Examination',

  // ---- ABMS certification (allopathic) ----
  'Allergy and Immunology Certification Examination',
  'Anesthesiology BASIC Examination',
  'Anesthesiology ADVANCED Examination',
  'Colon and Rectal Surgery Qualifying Examination',
  'Dermatology Certification Examination',
  'Emergency Medicine Qualifying Examination',
  'Family Medicine Certification Examination',
  'Internal Medicine Certification Examination',
  'Clinical Genetics and Genomics General Certification Examination',
  'Neurological Surgery Primary Examination',
  'Neurology Certification Examination',
  'Nuclear Medicine Certification Examination',
  'Obstetrics and Gynecology Qualifying Examination',
  'Ophthalmology Written Qualifying Examination',
  'Orthopaedic Surgery Part I (Written) Examination',
  'Otolaryngology-Head and Neck Surgery Qualifying Examination',
  'Anatomic Pathology and Clinical Pathology Certification Examination',
  'General Pediatrics Certification Examination',
  'PM&R Part I Certification Examination',
  'Plastic Surgery Written Examination',
  'Public Health and General Preventive Medicine Certification Examination',
  'Psychiatry Certification Examination',
  'Radiation Oncology Qualifying Examination',
  'Diagnostic Radiology Core Examination',
  'General Surgery Qualifying Examination',
  'Thoracic Surgery Written Examination',
  'Urology Qualifying (Part 1) Examination',
  'Vascular Surgery Qualifying Examination',

  // ---- Osteopathic (AOA) certification ----
  'Osteopathic Allergy and Immunology Certification Examination',
  'Osteopathic Anesthesiology Primary Certification Examination',
  'Osteopathic Dermatology Certification Examination',
  'Osteopathic Emergency Medicine Written Examination',
  'Osteopathic Family Medicine and OMT Certification Examination',
  'Osteopathic Internal Medicine Certification Examination',
  'Osteopathic Neurological Surgery Certification Examination',
  'Osteopathic Neurology Certification Examination',
  'Osteopathic Nuclear Medicine Certification Examination',
  'Osteopathic Obstetrics and Gynecology Written Examination',
  'Osteopathic Ophthalmology Certification Examination',
  'Osteopathic Orthopedic Surgery Written Certification Examination',
  'Osteopathic Otolaryngology-Facial Plastic Surgery Written Examination',
  'Osteopathic Pathology Certification Examination',
  'Osteopathic Pediatrics Written Certification Examination',
  'Osteopathic Physical Medicine and Rehabilitation Written Examination',
  'Osteopathic Plastic and Reconstructive Surgery Certification Examination',
  'Occupational & Preventive Medicine Osteopathic Certification Examination',
  'Osteopathic Psychiatry Written Certification Examination',
  'Osteopathic Diagnostic Radiology Certification Examination',
  'Osteopathic General Surgery Written Certification Examination',
  'Osteopathic Cardiothoracic Surgery Written Certification Examination',
  'Osteopathic Urology Written Certification Examination',
  'Osteopathic Vascular Surgery Written Certification Examination',

  // ---- Dental ----
  'INBDE - Integrated National Board Dental Examination',
  'ADAT - Advanced Dental Admission Test',

  // ---- Physician Assistant ----
  'PANCE - Physician Assistant National Certifying Examination',
  'PANRE - Physician Assistant National Recertifying Examination',
  'PANRE-LA - Physician Assistant National Recertifying Exam - Longitudinal Assessment',

  // ---- Nurse Practitioner (AANP, ANCC, NCC) ----
  'AANP Family Nurse Practitioner (FNP-C) Exam',
  'AANP Adult-Gerontology Primary Care NP (A-GNP-C) Exam',
  'ANCC Family Nurse Practitioner (FNP-BC) Exam',
  'ANCC Adult-Gerontology Primary Care NP (AGPCNP-BC) Exam',
  'ANCC Adult-Gerontology Acute Care NP (AGACNP-BC) Exam',
  'ANCC Psychiatric-Mental Health NP (PMHNP-BC) Exam',
  'ANCC Pediatric Primary Care NP (PPCNP-BC) Exam',
  'ANCC Pediatric Acute Care NP (PACNP-BC) Exam',
  'ANCC Neonatal NP (NNP-BC) Exam',
  'ANCC Emergency NP (ENP-BC) Exam',
  "ANCC Women's Health NP (WHNP-BC) Exam",
  'CPNP-PC - Primary Care Certified Pediatric Nurse Practitioner Exam',
  'CPNP-AC - Acute Care Certified Pediatric Nurse Practitioner Exam',
  "WHNP - Women's Health Nurse Practitioner Exam (NCC)",
  'NNP - Neonatal Nurse Practitioner Exam (NCC)',
] as const;

export type ExamName = (typeof EXAMS)[number];
